module.exports = __webpack_public_path__ + "img/bg.9be1d10b.jpg";